import React from 'react';
import './ErrorMessage.css';

export interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry }) => {
  return (
    <div className="error-message">
      {message}
      {onRetry && (
        <>
          <br />
          <button
            className="error-retry-button"
            onClick={onRetry}
          >
            Tekrar Dene
          </button>
        </>
      )}
    </div>
  );
};

export default ErrorMessage;

